import './AstrologerRegisterPage.css'
import PageLayout from '../components/layout/PageLayout'
import AstrologerRegisterSection from '../components/sections/astrologerRegister/AstrologerRegisterSection'

export default function AstrologerRegisterPage() {
  return (
    <PageLayout className="astro-register-page antialiased overflow-x-clip">

      {/* ── PAGE HERO ── */}
      <div className="relative overflow-hidden bg-astroDark text-white pt-40 pb-16">
        <div aria-hidden="true" className="absolute inset-0 bg-linear-to-b from-[#2a0e06] via-astroDark to-[#0c0703]" />
        <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(55%_70%_at_50%_0%,rgba(232,119,15,0.18),transparent_70%)]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 relative z-10 text-center">
          <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-goldPrimary mb-3">Join Our Panel</p>
          <h1 className="text-3xl md:text-5xl font-royal leading-tight">
            Become a Verified{' '}
            <span className="bg-linear-to-r from-goldPrimary via-amber-300 to-goldAccent bg-clip-text text-transparent font-semibold">
              Astrologer
            </span>
          </h1>
          <p className="text-white/50 text-sm mt-4 max-w-xl mx-auto font-light leading-relaxed">
            Share your Vedic knowledge with thousands of seekers. Complete the guided onboarding below — your profile
            is reviewed by our team before going live.
          </p>
        </div>
      </div>

      <AstrologerRegisterSection />

    </PageLayout>
  )
}
